import { Controller } from "stimulus";

window.bindSelect2withAjax = function(element) {
  $(element).select2({
    minimumInputLength: 3,
    dropdownCssClass: "sidebar-select2",
    placeholder: 'Start typing here',
    templateSelection: function (data, container) {
      $(container).addClass('sidebar-select2-selected');
      return data.text;
    },
    ajax: {
      contentType: 'application/json',
      dataType: 'json',
      url: element.dataset.url,
      data: function (params) {
        return {
          'q[full_name_cont]': params.term,
          page: params.page || 1
        };
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data.data,
          pagination: {
            more: (data.currentPage || 1) < (data.totalPages || 1)
          }
        };
      }
    }
  });

  $('.select2-ajax').next('.select2-container').addClass('sidebar-filters-select');

}

export default class extends Controller {

  connect() {
    this.bindAjaxSelect2();
  }

  bindAjaxSelect2() {
    $('.modal-controller').on('shown.bs.modal', function() {
      $('.select2-ajax').each(function(i, element) {
        bindSelect2withAjax(element);
      });
    });
  }
}
